// ─── Translations ──────────────────────────────────────────────────────────────
// Each locale lives in its own module for clean code organisation.
// All consumers keep the same synchronous API: translations[language]
import en from './translations/en';
import hi from './translations/hi';

export const translations = { en, hi };

// ─── Static Image URLs ─────────────────────────────────────────────────────────
export const images = {
  hero: {
    main: "https://images.pexels.com/photos/4664221/pexels-photo-4664221.jpeg",
    farmer: "https://images.pexels.com/photos/10845275/pexels-photo-10845275.jpeg",
    stable: "https://images.pexels.com/photos/12369706/pexels-photo-12369706.jpeg"
  },
  products: {
    copper: "https://images.pexels.com/photos/6166754/pexels-photo-6166754.jpeg",
    vessel: "https://images.unsplash.com/photo-1720414574223-40d393276746",
    clay: "https://images.unsplash.com/photo-1736752346246-61f4daedfde0"
  },
  cowCare: {
    care1: "https://images.pexels.com/photos/35545895/pexels-photo-35545895.jpeg",
    care2: "https://images.pexels.com/photos/17559673/pexels-photo-17559673.jpeg",
    care3: "https://images.unsplash.com/photo-1565346156504-91cca27d6e62"
  },
  quality: {
    pouring: "https://images.pexels.com/photos/8064112/pexels-photo-8064112.jpeg",
    milkBowl: "https://images.unsplash.com/photo-1686998424359-0356b707f3a1",
    cow: "https://images.unsplash.com/photo-1766066813747-99ef7a12251f"
  }
};

// ─── Contact Info ──────────────────────────────────────────────────────────────
export const contactInfo = {
  phone: "9039610400",
  whatsappMessage: "Hello! I'm interested in subscribing to RajDarshan Tandon Dairy's pure milk delivery service. Could you please provide more details?"
};
